import React, { useState, useEffect } from 'react';
import GridContainer from 'components/Grid/GridContainer';
import Modal from 'components/Tvendo/Common/ModalBase';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';

function EditModal(props) {
  const { setCreditNotes } = props;
  const creditNote = props.model;

  const [comment, setComment] = useState('');

  function onSave() {
    setCreditNotes((creditNotes) => {
      let index = creditNotes.findIndex((item) => item.id === creditNote.id);
      if (index === false) return creditNotes;
      creditNotes[index].comments = comment;
      return creditNotes;
    });
  }

  useEffect(() => {
    setComment(creditNote.comments || '');
  }, [creditNote]);

  return (
    <Modal
      title={`Nota crédito ${creditNote.id}`}
      model={props.model}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={onSave}
      entity="sale/credit-note"
    >
      <GridContainer>
        <GridItem xs={6}>
          <h6>Cliente</h6>
          <h5>{creditNote.CardName}</h5>
        </GridItem>
        <GridItem xs={6}>
          <h6>Vendedor</h6>
          <h5>{creditNote.SlpName}</h5>
        </GridItem>
        <GridItem xs={6}>
          <h6>Total</h6>
          <h5>{creditNote.total_order}</h5>
        </GridItem>
        <GridItem xs={6}>
          <h6>Fecha documento</h6>
          <h5>{creditNote.date_order}</h5>
        </GridItem>
      </GridContainer>
      <TextField
        label="Hoja reparto (Comentario)"
        fullWidth
        type="text"
        name="comments"
        margin="normal"
        value={comment || ''}
        onInput={(e) => {
          setComment(e.target.value);
        }}
        required
      />
    </Modal>
  );
}

export default EditModal;
